export default __webpack_public_path__ + "static/media/Thief's Gloves of the Tenth Court.f98bdd89.jpg";